/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DNSRecordInfo } from './dNSRecordInfo';
import { OAuthAppInfo } from './oAuthAppInfo';


export interface DeploymentRegionLinkResponse { 
    dns_info?: DNSRecordInfo;
    /**
     * URL of gateway
     */
    gateway_url: string;
    oauth_apps?: OAuthAppInfo;
}

